.header {
  background: var(--comp-header-color);
  box-shadow: inset 0 -1px 0 0 rgb(228 228 228 / 10%);
  box-sizing: border-box;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding: 3px 0;
  position: fixed;
  width: 100%;
  z-index: 99999;
}

.logo {
  height: 50px;
  margin-top: 4px;
}

.action,
.user {
  --avatar-size: 40px;

  background-color: var(--theme-white);
  color: var(--theme-dark-blue);
  font-size: 1.2rem;
  height: 40px;
  line-height: 40px;
  min-width: 40px;
  position: relative;
  text-align: center;
  user-select: none;
  vertical-align: middle;
}

.user>div {
  border-radius: var(--border-radius-medium) !important;
}

.action {
  cursor: pointer;
  font-size: var(--font-size-6);
  font-weight: 600;
  margin-left: 8px;
  text-decoration: none;
  width: 40px;
}

.user,
.user:hover {
  background-color: var(--theme-dark-blue);
  background-position: center;
  background-size: cover;
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: flex;
}

.action:hover {
  background-color: var(--theme-grey);
}

.headerLeft,
.headerCenter,
.headerRight {
  align-items: center;
  display: flex;
  max-width: 425px;
  width: 33.3333%;
}

.headerCenter {
  align-items: center;
  justify-content: space-evenly;
}

.headerRight {
  flex-direction: row-reverse;
  margin-right: 7px;
}

.headerLeft {
  margin-left: 7px;
}

.headerRight>*,
.headerLeft>* {
  margin: 0 3.5px;
}

.category {
  color: var(--comp-header-action-color);
  cursor: pointer;
  display: block;
  font-size: 1.5rem;
  height: 48px;
  line-height: 30px;
  padding: 5px 0;
  text-align: center;
  text-decoration: none;
  transition: filter 0.3s ease-in-out;
  user-select: none;
  width: 120px;
}

.category:hover {
  filter: brightness(1.5);
}

.category span {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 22px;
  margin: auto;
  max-width: 100px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category svg {
  height: 1.4rem;
}

.actionNotif {
  overflow: initial !important;
}

.signInButton {
  min-width: 100px;
}

.userMenu {
  background: var(--comp-header-action-menu-background-color);
  border: 1px solid #e4e4e41a;
  border-radius: var(--border-radius-small);
  box-shadow: var(--box-shadow-big);
  display: flex;
  flex-direction: column;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  right: var(--space-small);
  top: calc(60px + var(--space-small));
  transform: translateY(-10%);
  transition: all .3s ease-in-out;
  width: 250px;
}

.userMenuAction {
  align-items: center;
  color: var(--comp-header-action-menu-color);
  display: flex;
  font-size: var(--font-size-6);
  font-weight: 400;
  line-height: normal;
  padding: calc(1.5*var(--space-small));
  transition: all .3s ease-in-out;
  user-select: none;
}

.userMenuAction.logout:hover {
  color: var(--theme-red);
}

.userMenuAction span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto;
}

.userMenuActionPremium {
  color: #ab5d8d;
}

.userMenuAction svg {
  height: 18px;
  margin-right: var(--space-medium);
  width: 18px;
}

.userMenuAction:hover {
  filter: brightness(1.5);
}

.isOpened.closeLayer {
  cursor: default;
  inset: 0;
  position: fixed;
  z-index: 1;
}

.isOpened.userMenu {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0%);
  z-index: 2;
}

@media screen and (width <=475px) {
  .category span {
    font-size: 0.6rem;
  }
}

@media screen and (width <=375px) {
  .category span {
    font-size: 0.5rem;
  }
}

@media screen and (width <=300px) {
  .category span {
    display: none;
  }

  .category {
    line-height: 48px;
  }
}

@media screen and (width <=1050px) {
  .headerLeft {
    width: 40px;
  }

  .headerRight {
    width: auto;
  }

  .headerCenter {
    width: 50%;
  }
}

@media screen and (width <=800px) {
  .headerCenter.keyboardOpen {
    display: none !important;
  }

  .headerCenter {
    background: var(--comp-header-color);
    bottom: 0;
    box-shadow: 0 2px 8px 1px rgb(0 0 0 / 4%);
    box-sizing: border-box;
    display: flex;
    height: 60px;
    max-width: 100%;
    padding: 6px;
    position: fixed;
    width: 100%;
  }

  .category {
    width: 100%;
  }

  .headerLeft,
  .headerRight {
    display: flex;
    width: 50%;
  }
}

@media screen and (width <=375px) {
  .forceHideOnMobile {
    display: none;
  }
}